import OSS from 'ali-oss';

export default {
  ossClient: null,
  /**
   * OSS文件上传
   * @param {*} ossConfig OSS配置
   * @param {*} fileData 文件数据[Blob] 或者 Buffer.form('123456')
   * @param {*} dir OSS存储的目录
   * @param {*} fileName 文件名
   * @returns 
   */
  uploadFile: async function (ossConfig, fileData, dir, fileName) {
    // const ossConfig = {
    //   region: 'oss-cn-shenzhen', // 地区节点，比如 oss-cn-shenzhen
    //   accessKeyId: 'accessKeyId', // Access Key ID
    //   accessKeySecret: 'accessKeySecret', // Access Key Secret
    //   bucket: "bucketName", // Bucket 名称
    // }
    if (!this.ossClient) {
      this.ossClient = new OSS(ossConfig);
    }

    try {
      // 生成唯一的文件名
      const key = dir + '/' + fileName; // 生成新的文件名

      // 上传图片
      const result = await this.ossClient.put(key, fileData);
      // 返回图片的访问 URL
      return result;
    } catch (error) {
      console.error('上传失败', error);
      throw new Error('上传失败');
    }
  }
}